import {
    INVESTMENT_LOADING,
    INVESTMENT_SUCCESS,
    INVESTMENT_FAIL,
    GET_INVESTMENTS,
    GET_INVESTMENT_BY_ID,
    GET_INVESTMENT_STATISTICS,
    GET_INVESTMENT_HISTORY,
    CLEAR_INVESTMENT_ERROR,
    SET_INVESTMENT_VALIDATION_ERRORS
} from '../actions/InvestmentActions';

const initialState = {
    investments: [],
    currentInvestment: null,
    investmentHistory: [],
    statistics: {
        totalInvestments: 0,
        activeInvestments: 0,
        maturedInvestments: 0,
        closedInvestments: 0,
        totalInvestedAmount: 0,
        totalActiveAmount: 0,
        totalReturnedAmount: 0,
        totalProfit: 0
    },
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        recordsPerPage: 10
    },
    historyPagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        recordsPerPage: 50
    },
    loading: false,
    error: null,
    validationErrors: []
};

const investmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case INVESTMENT_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case INVESTMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                currentInvestment: action.payload,
                error: null,
                validationErrors: []
            };

        case INVESTMENT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case GET_INVESTMENTS:
            return {
                ...state,
                investments: action.payload.data,
                pagination: action.payload.pagination,
                loading: false,
                error: null
            };

        case GET_INVESTMENT_BY_ID:
            return {
                ...state,
                currentInvestment: action.payload,
                loading: false,
                error: null
            };

        case GET_INVESTMENT_STATISTICS:
            return {
                ...state,
                statistics: action.payload,
                loading: false,
                error: null
            };

        case GET_INVESTMENT_HISTORY:
            return {
                ...state,
                investmentHistory: action.payload.data,
                historyPagination: action.payload.pagination,
                loading: false,
                error: null
            };

        case SET_INVESTMENT_VALIDATION_ERRORS:
            return {
                ...state,
                validationErrors: action.payload,
                loading: false
            };

        case CLEAR_INVESTMENT_ERROR:
            return {
                ...state,
                error: null,
                validationErrors: []
            };

        default:
            return state;
    }
};

export default investmentReducer;
